import React, { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './signature.css'
import { Link} from 'react-router-dom'


// import icons
import {HiOutlineLocationMarker} from 'react-icons/hi'

import img9 from '../../Assets/signImg/img9.jpeg'

const Data = [
    {
        id:9,
        imgSrc: img9,
        destTitle: '世紀前沿 - 美國商業教育與企業',
        location: '美國 · 新英格蘭',
        grade: '12-23',
        fees:'2990 美元',
        description:'美國東海岸是國家誕生之地，匯聚最古老且頂尖的大學、研究機構，以及生物科學、醫藥研發、機器人技術、互聯網、金融保險等前沿產業。在這裡，歷史與創新交匯，你將親眼見證未來。'
      },
  ]

export default function Signature9() {

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])

  return (
<section className='signMain signContainer signSection '>
    <div className='signSecTitle'>
        <h3 data-aos='fade-right' className='signTitle'>
        世 紀 前 沿 - 美 國 商 業 教 育 與 企 業
        </h3>
        <button className='signHomeBtn'><Link to={'/'} className='signHomeBtnLink'>返回首頁</Link></button>
    </div>

    <div className='signSecContent signGrid'>
        { 
            Data.map(({id, imgSrc, destTitle, location, company, fees, description})=>{

                return(
                <div key={id} data-aos='fade-up' className='signSingleDestination'>
                    
                    <div className='signCardInfo'>
                        <h4 className='signDestTitle'>{destTitle}</h4>
                        <span className='signContinent signFlex'>
                        <HiOutlineLocationMarker className='icon' />
                            <span className='signName'>{location}</span>
                        </span>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                <span>
                                {/* 执行机构：{company} */}
                                    <br/>
                                    <small>⭐️ 行 程 精 華 ⭐️</small>
                                    <br/><br/>
                                </span>
                            </div>
                        <div>
                        <br/><p><b>{description}</b></p><br/>
                                
                                <table width='70%'>
                                    <thead>
                                        <tr>
                                            <th width='20%'></th>
                                            <th width='10%'></th>
                                            <th width='70%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                         <tr>
                                            <td>企業參觀</td>
                                            <td>     </td>
                                            <td>；
                                            </td>
                                            
                                        </tr><br/>
                                        <tr>
                                            <td>大學研究</td>
                                            <td></td>
                                            <td>；</td>

                                        </tr><br/>
                                        <tr>
                                            <td>社會體驗</td>
                                            <td></td>
                                            <td>；</td>

                                        </tr><br/>
                                        <tr>
                                            <td>名勝古蹟</td>
                                            <td></td>
                                            <td>；</td>
                                        </tr><br/>

                                    </tbody>
                                </table>
                            </div>
                            

                        </div>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                        <span>
                                            <small>⭐️ 參 團 資 訊 ⭐️</small>
                                        </span>
                                        <br/><br/>
                            </div> <br/>
                            <table width='70%'>
                                    <thead>
                                        <tr>
                                            <th width='15%'></th>
                                            <th width='10%'></th>
                                            <th width='75%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>參團年齡</td>
                                            <td>     </td>
                                            <td>14-21歲學生</td>
                                        </tr><br/>
                                        <tr>
                                            <td>適合人群</td>
                                            <td>     </td>
                                            <td>；</td>
                                        </tr><br/>
                                        <tr>
                                            <td>時間安排</td>
                                            <td>     </td>
                                            <td>6月「為期12天」</td>
                                        </tr><br/>
                                        <tr>
                                            <td>地 點</td>
                                            <td>     </td>
                                            <td>美國 · 新英格蘭</td>
                                        </tr><br/>
                                        <tr>
                                            <td>费 用 包 括</td>
                                            <td>     </td>
                                            <td>在美國期間的參觀學習費用，餐飲費用，住宿費用，交通費用，門票費用；
                                            </td>
                                        </tr><br/>
                                        <tr>
                                            <td>費用不包含</td>
                                            <td>     </td>
                                            <td>
                                                國際旅行手續費、往返國際機票、國際旅行醫療保險、意外保險、個人購物、個人消費。
                                            </td>
                                        </tr><br/>
                                    </tbody>
                            </table>
                        </div>

                    <div className='signFees'>
                        <div className='signGrade'>
                                    <span>
                                        <small>⭐️ 參 考 行 程 ⭐️</small>
                                    </span>
                                    <br/><br/>
                        </div>
                        <br/>
                        <h6>行程範例</h6>
                        <p>實際活動內容可能會有前後調整，或被相近內容替代；夏令營正式開始前四週確定行程細節。</p>
                        <br/>
                        <table width='100%'>
                                        <thead>
                                            <tr>
                                                <th width='10%'>日  期</th>
                                                <th width='40%'>上 午 活 動</th>
                                                <th width='50%'>下 午 活 動</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <br/>
                                            <tr>
                                                <td>第一日</td>
                                                <td>出發</td>
                                                <td>抵達美國</td>
                                            </tr>
                                            <tr>
                                                <td>第二日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第三日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>第四日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>第五日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>第六日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>第七日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第八日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>第九日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第十日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>第十一日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>第十二日</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                            </table>

                            <div className='signGrade'>
                        <span>
                            <small>⭐️ 課 程 和 活 動 說 明 ⭐️</small>
                        </span>
                             <br/><br/>
                    </div> 
                            <br/>
                        
                        <h6>每日活動內容包括但不限於（示例行程中的校外活動，由以下活動組成）：</h6>
                        <p>
                            <b>高等教育及研究所: </b>
                            ；
                            <br/>
                            <b>政府及社會機構: </b>
                           ；
                            <br/>
                            <b>企業: </b>
                           ；
                            <br/>
                            <b>遊覽: </b>
                            ；
                            <br/>
                        </p>
                    </div>
                    
                        <div className='signPrice'>
                            <h5>预 售 价 格 ：{fees}</h5>
                        </div>
                        <Link to={"/formReg"} target="_blank">
                        <button className='signBtn signFees'>
                            <h4>⭐️ ⭐️ ⭐️  預 約 報 名 - 搶 先 卡 位  ⭐️ ⭐️ ⭐️</h4>
                         </button>
                         </Link>
                </div>
                    <div className='signImageDiv'>
                        <img src={imgSrc} alt={destTitle}/>
                    </div>

                </div>
                )
            })
        
        }
       
    </div>

</section>
  )
}
